export default __webpack_public_path__ + "static/media/Soulblessed Rod.8d7c85c5.jpg";